export const UrlQueryKey = {
    FDS_RESULT: 'fdsResult',
    ORDER_RESULT: 'result',
    INIT_GIFT: 'gift',
}

export type UrlQueryKeyType = Constant<typeof UrlQueryKey>

/**
 * 카테고리 구분자
 * url?category=A.B.C
 **/
export const CATEGORY_DIVISION_KEY = '.'
